<template>
  <v-container class="pa-0" style="width: auto">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          style="width: auto; height: auto"
          v-bind="attrs"
          small
          v-on="on"
          @click="
            openLink(
              'https://abriron.com/%d8%a8%d8%b1%d9%88%d8%b2%d8%b1%d8%b3%d8%a7%d9%86%db%8c-%d9%87%d8%a7/'
            )
          "
        >
          <my-icon
            :name="'update-icon'"
            :stroke="$vuetify.theme.isDark ? '#fff' : '#000'"
            :width="18"
            :height="18"
            :cursor-pointer="true"
          />
        </v-btn>
      </template>
      <span>{{ $t("updated") }}</span>
    </v-tooltip>
  </v-container>
</template>

<script>
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";

export default {
  methods: {
    openLink(link) {
      window.open(link, "_blank");
    },
  },
  components: {
    MyIcon,
  },
};
</script>

<style lang="scss" scoped></style>
